export default "/images/6970417ec1e548ef75b2b4eee44effaf.avif";